import { makeAccessible } from '@/utils/makeAccessible';
import type { Row } from '@tanstack/react-table';
import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { TableElement } from '../../types';

type TableRowProps<T extends TableElement> = {
  index: number;
  row?: Row<T>;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (row: Row<T>) => void;
};

export const TableRow = <T extends TableElement>({ index, row, children, className, style, onClick }: PropsWithChildren<TableRowProps<T>>) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClick?.(row);
  };

  return (
    <tr
      data-index={index}
      className={twMerge(
        'group/row text-primary-900 motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none bg-white-100',
        onClick ? 'hover:bg-brand-50' : '',
        className
      )}
      style={style}
      {...(onClick ? makeAccessible(handleClick) : {})}
    >
      {children}
    </tr>
  );
};
